import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";

export class BreadCrumbItem {
  public name: string;
  public url: string;
  constructor(name = "", url = "") {
    this.name = name;
    this.url = url;
  }
}

export const BreadCrumbList = ({ items }: { items: BreadCrumbItem[] }) => {
  const listItems = items.map((item: BreadCrumbItem, index: number) => {
    if (item.name === "") {
      return null;
    }
    if (index === items.length - 1) {
      return <div key={index}>{item.name}</div>;
    }
    return (
      <Link to={item.url} key={index}>
        {item.name}
      </Link>
    );
  });
  return <Breadcrumbs>{listItems}</Breadcrumbs>;
};
